import React, { forwardRef, useEffect, useImperativeHandle, useState, useRef } from "react";
import { Col, Row } from "react-bootstrap";
import CreatableSelect from 'react-select/creatable';
import IFormWithConfig from "../../../../models/misconfig/FormWithConfig";
import ISimsUserTypeMapping from "../../../../models/misconfig/sims/SimsUserTypeMapping";

const SimsUserTypeEdit = forwardRef((props: IFormWithConfig, ref) => {
    const [SIMsConfig, setSIMsConfig] = useState<ISimsUserTypeMapping | null>(null);
    const [errors, setErrors] = useState<{ [key: string]: string }>({});

    const hasInitializedRef = useRef(false);

    useEffect(() => {        
        if (props.configJson) {
            const configObj: ISimsUserTypeMapping = JSON.parse(props.configJson);
            setSIMsConfig(configObj);
            hasInitializedRef.current = true;
        } else {
            hasInitializedRef.current = false;
            setSIMsConfig({
                reportName: '',
                photoReportName: '',
            });
        }
    }, [props.configJson]);

    useImperativeHandle(ref, () => ({
            validate: function() : boolean {
                const newErrors: { [key: string]: string } = {};
                
                if(!SIMsConfig?.reportName || SIMsConfig.reportName.trim() === '') {
                    newErrors['reportName'] = 'Report name is required';
                } 

                if(!SIMsConfig?.photoReportName || SIMsConfig.photoReportName.trim() === '') {
                    newErrors['photoReportName'] = 'Photos Report name is required';
                }
    
                setErrors(newErrors);
                return Object.keys(newErrors).length === 0;
            }
        }));

    const dataReportOptions = [
        {
            value: 'Student Extract',
            label: 'Student Extract'
        },
        {
            value: 'Applicant Extract',
            label: 'Applicant Extract'
        },
        {
            value: 'Staff Extract',
            label: 'Staff Extract'
        }
    ];

    const photoReportOptions = [
        {
            value: 'Student Photos Extract',
            label: 'Student Photos Extract'
        },
        {
            value: 'Applicant Photos Extract',
            label: 'Applicant Photos Extract'
        },
        {
            value: 'Staff Photos Extract',
            label: 'Staff Photos Extract'
        }
    ]

    const handleChange = (key: string, value: any) => {
        if(SIMsConfig === null) {
            return;
        }
        const updatedConfig = { ...SIMsConfig, [key]: value };
        setSIMsConfig(updatedConfig);
        props.setJsonString(JSON.stringify(updatedConfig));
    }

    return (        
        <React.Fragment>
            <Row className="pb-3">
                <Col md={props.firstCol}>Data Report Name</Col>
                <Col md={props.secondCol}>
                    <CreatableSelect
                        isClearable
                        placeholder={"Type or Select"}
                        className={`${(errors.reportName) ? 'is-invalid' : ''}`}
                        defaultInputValue={SIMsConfig?.reportName ?? ""}
                        value={SIMsConfig ? { value: SIMsConfig.reportName, label: SIMsConfig.reportName } : null}
                        options={dataReportOptions}
                        onChange={val => handleChange('reportName', val?.value)}
                        required />
                    {errors.reportName && <div className="invalid-feedback">Data Report Name is required</div>}
                </Col>
            </Row>
            <Row className="pb-3">
                <Col md={props.firstCol}>Photos Report Name</Col>
                <Col md={props.secondCol}>
                     <CreatableSelect
                        isClearable
                        placeholder={"Type or Select"}
                        className={`${(errors.photoReportName) ? 'is-invalid' : ''}`}
                        defaultInputValue={SIMsConfig?.photoReportName ?? ""}
                        value={SIMsConfig ? { value: SIMsConfig.photoReportName, label: SIMsConfig.photoReportName } : null}
                        options={photoReportOptions}
                        onChange={val => handleChange('photoReportName', val?.value)} />
                    {errors.photoReportName && <div className="invalid-feedback">Photos Report Name is required</div>}
                </Col>
            </Row>
        </React.Fragment>  
    );
});

export default SimsUserTypeEdit;